module.exports = __webpack_public_path__ + "img/318.6692b9e0.jpg";